import { render } from "./add_lab_test_modal.vue?vue&type=template&id=b345193c"
import script from "./add_lab_test_modal.vue?vue&type=script&lang=js"
export * from "./add_lab_test_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__